import { getAllParameters } from "./functions";

export const tabsInit = () => {
    // タブコンテナを全て取得
    const tabContainers = document.querySelectorAll(".tabs");

    const params = getAllParameters();
    // console.log(params);

    tabContainers.forEach((container) => {
        let tabs, pages;

        if (container.classList.contains("Tnews__innerMain")) {
            tabs = container.querySelectorAll(".Tnews__innerMainCatsCat");
            pages = container.querySelectorAll(".Tnews__innerMainTabsTab");
        } else {
            tabs = container.querySelectorAll(".tabs__tab");
            pages = container.querySelectorAll(".tabs__page");
        }

        if (tabs.length && pages.length) {
            // .tabsのdata-page属性を確認
            let initialIndex = 0;
            if (container.hasAttribute("data-page")) {
                initialIndex =
                    parseInt(container.getAttribute("data-page"), 10) - 1;
                initialIndex = Math.max(
                    0,
                    Math.min(initialIndex, pages.length - 1)
                ); // 範囲内に収める
            }

            const activeIndex = params["tabid"]
                ? container.dataset.tabId === params["tabid"]
                    ? Number(params["tabindex"])
                    : initialIndex
                : initialIndex;

            tabs[activeIndex].classList.add("is-on");
            pages[activeIndex].classList.add("is-on");

            // 各タブにクリックイベントを追加
            tabs.forEach((tab, index) => {
                tab.addEventListener("click", () => {
                    // 全てのタブとページから'is-on'クラスを削除
                    tabs.forEach((t) => t.classList.remove("is-on"));
                    pages.forEach((p) => p.classList.remove("is-on"));

                    // クリックされたタブとそれに対応するページをアクティブにする
                    tab.classList.add("is-on");
                    pages[index].classList.add("is-on");
                });
            });
        }
    });
};

// 関数を実行
tabsInit();
